/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Supported semantic accent colors for widget labels.
 */
export enum ReportWidgetAccentColor {
    PRIMARY = 'primary',
    SECONDARY = 'secondary',
    NEUTRAL = 'neutral',
    DANGER = 'danger',
    WARNING = 'warning',
    SUCCESS = 'success',
    INFO = 'info',
    WHATSAPP = 'whatsapp',
    CALL = 'call',
    EMAIL = 'email',
}
